import { getJsonWithAccountId } from '@zapier/toolbox-browser-fetch';
import {
  commonErrors as Errors,
  resourceNames,
} from '@zapier/toolbox-redux-framework';

import z from 'app/common/z';

const Data = {
  loadHeldReasons(accountId) {
    return getJsonWithAccountId(accountId, `${z.cfg.api}/stream/held`).catch(
      response => {
        throw new Errors.DataGetError({
          resource: resourceNames.heldReasons,
          response,
        });
      }
    );
  },
};

export default Data;
